module.exports = __webpack_public_path__ + "img/feedback.05b4b313.png";